export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"theme-color","content":"#73237D"},{"name":"google-site-verification","content":"5BT1rV1E4iXj5v--j2-v7DmoxlCtaL4xeFODra8Lqd8"},{"hid":"og-type","property":"og:url","content":"https://ajvaccines.com/"},{"hid":"og-type","property":"og:type","content":"website"},{"hid":"og-type","property":"og:title","content":"AJ Vaccines | Together, we keep the world safe "},{"hid":"og-type","property":"og:description","content":"AJ Vaccines is a global pharmaceutical company. We develop and manufacture vaccines against serious infectious diseases as well as diagnostic and therapeutic solutions."},{"hid":"og-type","property":"og:image","content":""}],"link":[{"rel":"canonical","href":"https://ajvaccines.com/"},{"rel":"icon","href":"/favicon.svg"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png"},{"rel":"mask-icon","type":"image/x-icon","href":"/favicon_mask.svg","color":"#73237D"}],"style":[],"script":[],"noscript":[],"title":"AJ Vaccines"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false